import React from "react";
import {
  IconLeft,
  IconLeftDouble,
  IconRight,
  IconRightDouble,
} from "../common/icons";
import { generatePagination } from "../../utils/utils";

const Pagination = ({ current, pages, onNewPage }) => {
  let listPages = generatePagination(current, pages);

  return (
    <div className="rd--pagination">
      <div
        className={`el left2 ${current > 2 ? "show pointer" : "hide"}`}
        onClick={() => current > 2 && onNewPage(current - 2)}
      >
        <IconLeftDouble />
      </div>
      <div
        className={`el left ${current > 1 ? "show pointer" : "hide"}`}
        onClick={() => current > 1 && onNewPage(current - 1)}
      >
        <IconLeft />
      </div>
      {listPages.map((pageFromList, index) => (
        <div
          key={index}
          className={`el title-08 ${
            index === 0 ? "first" : index === pages ? "last" : ""
          } ${current == pageFromList && "current"} ${
            pageFromList !== "..." && "pointer"
          }`}
          onClick={() => pageFromList !== "..." && onNewPage(pageFromList)}
        >
          {pageFromList}
        </div>
      ))}
      <div
        className={`el right ${current < pages ? "show pointer" : "hide"}`}
        onClick={() => current < pages && onNewPage(current + 1)}
      >
        <IconRight />
      </div>
      <div
        className={`el right2 ${current < pages - 1 ? "show pointer" : "hide"}`}
        onClick={() => current < pages - 1 && onNewPage(current + 2)}
      >
        <IconRightDouble />
      </div>
    </div>
  );
};
export default Pagination;
